
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="13dd5fc6-77c9-59c3-b5a4-7effb8f52b2b")}catch(e){}}();
import { getJSONData, postData, postJSONData } from '/static/js/network.js';
import { setupDocumentEventListeners, obscure_email, obscure_phone, start_countdown_timer, stop_countdown_timer, pop_toast, runWithBusy } from '/static/js/utilities.js';
import { applyAccountPageVersion } from '/static/js/account/page-version.js';
import { applyLastLoginAutoOnLoginPage, saveLastLogin } from '/static/js/account/last-login.js';
import { handler__take_photo } from '/static/js/photos/photos.js';
import * as luxon from 'https://cdn.jsdelivr.net/npm/luxon@3.6.1/+esm';

function api__search_for_tag_or_vin(tag, tag_state) {
    console.log(`api__search_for_tag_or_vin(tag=${tag}, tag_state=${tag_state})`);
    return Promise.all(
      [
        getJSONData(`/api/vehicle/by-tag-state/${tag}/${tag_state}/`),
        getJSONData(`/api/vehicle/by-vin/${tag}/`)
      ]
    );
}

/**
 * Parse build_response format to extract emails and phones for password reset.
 * Returns format compatible with existing handler: {valid, claimed, emails: [[id, value], ...], phones: [[id, value], ...]}
 * @param {object} rv - Response from Api_VehicleByTagState using build_response format
 * @returns {object} - Normalized response for password reset flow
 */
function parseBuildResponseForPasswordReset(rv) {
    if (!rv.valid) {
        return {valid: false, emails: [], phones: []};
    }

    // Get the first vehicle
    const vehicleId = rv.vehicles?.ordered_ids?.[0];
    if (!vehicleId) {
        return {valid: false, emails: [], phones: []};
    }

    const vehicle = rv.vehicles.all[vehicleId];
    const claimed = vehicle?.claimed_by_authed_account || false;

    // Collect emails and phones from all persons associated with the vehicle
    const emails = [];
    const phones = [];

    // Get owner from vehicle
    const ownerId = vehicle?.owner;
    if (ownerId && rv.persons?.all?.[ownerId]) {
        const person = rv.persons.all[ownerId];

        // Try to get emails from the emails collection first
        if (person.emails && rv.emails?.all) {
            person.emails.forEach((emailId) => {
                const emailObj = rv.emails.all[emailId];
                if (emailObj && emailObj.email && emailObj.email !== '<blocked>') {
                    emails.push([person.id, emailObj.email]);
                }
            });
        }

        // Fallback to legacy person.email field if no Email objects found
        if (emails.length === 0 && person.email && person.email !== '<blocked>') {
            emails.push([person.id, person.email]);
        }

        // Try to get phones from the phones collection first
        if (person.phones && rv.phones?.all) {
            person.phones.forEach((phoneId) => {
                const phoneObj = rv.phones.all[phoneId];
                if (phoneObj && phoneObj.number && phoneObj.number !== '<blocked>') {
                    phones.push([person.id, phoneObj.number]);
                }
            });
        }

        // Fallback to legacy person.phone field if no Phone objects found
        if (phones.length === 0 && person.phone && person.phone !== '<blocked>') {
            phones.push([person.id, person.phone]);
        }
    }

    return {valid: true, claimed, emails, phones};
}

/* set/unset 'checked' on cards
 */
function handler__click__registration_type_card(ev) {
    const ev_classes = ev.target.classList;
    let el = ev.target;
    let is_registration_card = false;
    let is_authenticate_button = false;

    while (el && el.id !== 'registration-options') {
        if (el.nodeName === 'UL') {
            break;
        } else {
            if (el.classList.contains('registration-type-card')) {
                is_registration_card = true;
                break;
            }
            else if (el.classList.contains('authenticate-button')) {
                is_authenticate_button = true;
                break;
            }
            else if (el.classList.contains('help-login-button')) {
                showForgotPasswordSection();
                return;
            }
            else if (el.classList.contains('open-parkranger-login')) {
                // Opening the ParkRanger overlay must not clear registration cards.
                return;
            }

            el = el.parentElement;
        }
    }

    if (is_authenticate_button) {
        return;
    }

    const currentlyChecked = is_registration_card && ev_classes.contains('checked');

    // if currently checked, uncheck
    // if not checked, uncheck all others then check
    if (currentlyChecked) {
        el.classList.remove('checked');
    } else {
        [...document.querySelectorAll('.registration-type-card')]
            .forEach((q_el) => q_el.classList.remove('checked'));

        if (is_registration_card) {
            el.classList.add('checked');
            // A card is now selected; drop the "select a card first" hint.
            [...document.querySelectorAll('.register-card.needs-selection')]
                .forEach((cards) => cards.classList.remove('needs-selection'));
        }
    }
}

function handler__click__register_me(ev) {
    // These buttons may be real <button type="submit"> inside a POST form
    // (social:begin requires POST as of social-auth-app-django 6.0.0). Take
    // control of navigation ourselves so validation can block submission.
    ev.preventDefault();

    const user_type = document.querySelectorAll('.registration-type-card.checked');
    if (user_type.length !== 1) {
        // Previously this only logged to the console, so the "Continue with …"
        // buttons looked broken until the user happened to discover the card
        // requirement. Tell them explicitly and highlight the cards.
        pop_toast({
            topic: 'Choose an account type',
            message: 'Please select an account type (for example Visitor or Resident) above, then tap “Continue with …” again.',
            warning: true,
        });
        const cards = ev.target.closest('section')?.querySelector('.register-card')
            || document.querySelector('.register-card.community');
        if (cards) {
            cards.classList.add('needs-selection');
            cards.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
        return;
    }

    let el = ev.target;
    while (el.nodeName !== 'BUTTON') {
        el = el.parentElement;
    }

    const type = user_type[0].getAttribute('data-type');
    console.log(`setting profile registration type to ${type}`);

    // Social sign-up: the button lives inside a POST form to social:begin.
    // Stash the chosen profile_type and submit the form (POST + CSRF token).
    const form = el.closest('form');
    if (form) {
        let hidden = form.querySelector('input[name="profile_type"]');
        if (!hidden) {
            hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'profile_type';
            form.appendChild(hidden);
        }
        hidden.value = type;
        markGoogleOauthButtonPending(el);
        form.submit();
        return;
    }

    // Non-social register (e.g. ParkRanger): plain GET navigation.
    let action = `${el.getAttribute('action')}?profile_type=${type}`;
    console.log(`action: ${action}`);
    location.assign(action);
}

/**
 * Update the send-reset-link button state based on whether any checkboxes are checked
 */
function updateSendResetLinkButtonState() {
    const dl_el = document.querySelector('#forgot-email-password .search-result dl');
    const sendButton = document.querySelector('#forgot-email-password button[name="send-reset-link"]');
    
    if (!dl_el || !sendButton) {
        return;
    }
    
    const checkboxes = dl_el.querySelectorAll('input[type="checkbox"]');
    const hasChecked = Array.from(checkboxes).some(cb => cb.checked);
    
    if (hasChecked) {
        sendButton.removeAttribute('disabled');
    } else {
        sendButton.setAttribute('disabled', true);
    }
}

function handler__click__send_reset_link(ev) {
    const dl_el = document.querySelector('#forgot-email-password .search-result dl');
    const sendButton = document.querySelector('#forgot-email-password button[name="send-reset-link"]');
    
    if (!dl_el || !sendButton) {
        return;
    }
    
    // Collect selected checkboxes
    const checkboxes = dl_el.querySelectorAll('input[type="checkbox"]:checked');
    if (checkboxes.length === 0) {
        return;
    }
    
    const contacts = Array.from(checkboxes).map(cb => ({
        person_id: parseInt(cb.getAttribute('data-person-id'), 10),
        value: cb.getAttribute('data-contact-value'),
        type: cb.getAttribute('data-contact-type')
    }));
    
    sendButton.classList.add('activated');
    
    postJSONData('/account/password/reset/by-vehicle/send/', {contacts: contacts}, {fetch_msg: 'Sending password reset PINs'})
        .then((response) => {
            sendButton.classList.remove('activated');
            
            if (response.valid) {
                const search_result_el = document.querySelector('#forgot-email-password .search-result p');
                const successCount = response.results.filter(r => r.valid).length;
                const totalCount = response.results.length;
                
                if (successCount === totalCount) {
                    search_result_el.innerHTML = `Password reset PINs have been sent to ${successCount} contact${successCount > 1 ? 's' : ''}. Check your email and/or phone for the 6-digit PIN codes.`;
                    
                    // Store profile_id from first successful result and show PIN section
                    const firstSuccess = response.results.find(r => r.valid);
                    if (firstSuccess && firstSuccess.profile_id) {
                        const pinSection = document.querySelector('#password-reset-pin-section');
                        if (pinSection) {
                            pinSection.classList.remove('hidden');
                            pinSection.scrollIntoView({block: 'center', behavior: 'smooth'});
                            
                            // Store profile_id on the PIN input for later use
                            const pinInput = document.querySelector('#password-reset-pin-received');
                            if (pinInput) {
                                pinInput.setAttribute('data-profile-id', firstSuccess.profile_id);
                                pinInput.removeAttribute('disabled');
                                pinInput.focus();
                                
                                // Determine method from the contact type
                                const selectedCheckbox = Array.from(dl_el.querySelectorAll('input[type="checkbox"]:checked'))[0];
                                if (selectedCheckbox) {
                                    const contactType = selectedCheckbox.getAttribute('data-contact-type');
                                    pinInput.setAttribute('data-method', contactType === 'phone' ? 'sms' : 'email');
                                }
                            }
                            
                            // Start countdown timer (15 minutes = 900 seconds)
                            const timerEl = document.querySelector('#password-reset-pin-timer');
                            if (timerEl) {
                                const timesent = response.pin_timestamp 
                                    ? luxon.DateTime.fromISO(response.pin_timestamp)
                                    : luxon.DateTime.now();
                                start_countdown_timer(timerEl, timesent, 900)
                                    .then(() => {
                                        console.log('PIN timer expired');
                                        const pinInput = document.querySelector('#password-reset-pin-received');
                                        if (pinInput) {
                                            pinInput.setAttribute('disabled', 'disabled');
                                        }
                                    });
                            }
                        }
                    }
                } else {
                    const failed = response.results.filter(r => !r.valid);
                    search_result_el.innerHTML = `Sent to ${successCount} of ${totalCount} contacts. Some failed: ${failed.map(f => f.msg).join(', ')}`;
                }
            } else {
                const search_result_el = document.querySelector('#forgot-email-password .search-result p');
                const errors = response.results ? response.results.filter(r => !r.valid).map(r => r.msg).join(', ') : response.msg || 'Failed to send reset PINs';
                search_result_el.innerHTML = `Error: ${errors}`;
            }
        })
        .catch((err) => {
            console.error(err);
            sendButton.classList.remove('activated');
            const search_result_el = document.querySelector('#forgot-email-password .search-result p');
            search_result_el.innerHTML = 'Error sending password reset PINs';
        });
}

function handler__click__search_forgottens(ev) {
    console.log(ev);
    let el = ev.target;

    while (el.nodeName !== 'BUTTON' && !(el.nodeName === 'DIV' && el.classList.contains('img-wrapper'))) {
        el = el.parentElement;
        if (!el) {
            console.log('no booyah', ev.target);
            return;
        }
    }

    console.log('shabooyah', el);

    const name = el.getAttribute('name');
    let object_type;
    let value;

    // take photo
    if (ev.type === 'click' && el.nodeName === 'DIV' && el.classList.contains('img-wrapper')) {
        const input = el.parentNode.closest('div').querySelector('input[type="file"]');
        input.click();
        return;
    }

    // delete photo
    else if (ev.type === 'click' && el.classList.contains('delete')) {
        while (['BUTTON', 'DIV'].indexOf(el.nodeName) <0 ) {
            el = el.parentElement;
        }

        const parent = el.closest('div').querySelector('.img-wrapper');
        console.log(parent);
        const img = new document.createElement('img');
        const input = parent.parentNode.closest('div').querySelector('input[type="file"]');
        parent.lastElementChild.remove();
        img.classList.add('photo-preview');
        img.classList.add('hidden');
        parent.appendChild(img);
        parent.classList.remove('retake');
        input.value = '';

        document.querySelector('#forgot-email-password button[name="id-me"]').setAttribute('disabled', true);

        value = '';
        object_type = 'vehicle-photo';
        return;
    }

    else if (name === 'id-me') {
        // see if the photo preview has content
        // const photo_front = document.querySelector('#forgot-email-password img[name="driver-license-photo-front"]');
        // if (photo_front && photo_front.src) {
        //     postData('/photos/analyze/driverlicense/front/',
        //         {photo: photo_front.src},
        //         {fetch_msg: 'attempting to decode DL front'}
        //     )
        //         .then((response) => {
        //             console.log(response);
        //         });
        // }

        const photo_back = document.querySelector('#forgot-email-password img[name="driver-license-photo-back"]');
        if (photo_back && photo_back.src) {
            postData(
                '/photos/analyze/driverlicense/back/',
                {photo: photo_back.src},
                {fetch_msg: 'attempting to decode DL back'}
            )
                .then((response) => {
                    console.log(response);
                });
        }

    }

    if (name === 'cancel') {
        const forgotSection = document.querySelector('#forgot-email-password');
        if (forgotSection) {
            const tagInput = forgotSection.querySelector('input#vehicle-tag');
            const stateSelect = forgotSection.querySelector('select#vehicle-tag-state');
            const searchResultP = forgotSection.querySelector('.search-result p');
            const searchResultDl = forgotSection.querySelector('.search-result dl');
            
            if (tagInput) tagInput.value = '';
            if (stateSelect) stateSelect.selectedIndex = 0;
            if (searchResultP) searchResultP.innerHTML = '';
            if (searchResultDl) searchResultDl.innerHTML = '';
            forgotSection.classList.add('hidden');
        }
        return;
    }

    else if (name === 'find') {
        const forgotSection = document.querySelector('#forgot-email-password');
        if (!forgotSection) {
            console.warn('Could not find #forgot-email-password section');
            return;
        }
        const tagInput = forgotSection.querySelector('input#vehicle-tag');
        const stateSelect = forgotSection.querySelector('select#vehicle-tag-state');
        if (!tagInput || !stateSelect) {
            console.warn('Could not find tag input or state select');
            return;
        }
        const tag = tagInput.value.trim();
        const tag_state = stateSelect.value;

        if (tag.length === 0) {
            console.warn('tag is empty');
            return;
        }
        if (!tag_state) {
            console.warn('tag_state is not selected');
            const search_result_el = forgotSection.querySelector('.search-result p');
            if (search_result_el) {
                search_result_el.innerHTML = 'Please select a state';
            }
            return;
        }

        el.classList.add('activated');
        api__search_for_tag_or_vin(tag, tag_state)
        .then((res) => {
            console.log('api__search_for_tag_or_vin response:', res);
            el.classList.remove('activated');

            // res[0] is by-tag-state (build_response format), res[1] is by-vin (old format)
            const [tagStateResponse, vinResponse] = res;

            // Parse the tag-state response from build_response format
            const tagResult = parseBuildResponseForPasswordReset(tagStateResponse);

            // VIN response is already in the correct format (from Api_GetVehicleIdByVin)
            const vinResult = vinResponse?.valid ? vinResponse : {valid: false, emails: [], phones: []};

            // Process whichever is valid (tag-state takes precedence)
            const rv = tagResult.valid ? tagResult : vinResult;

            if (rv.valid) {
                if (rv.emails.length === 0 && rv.phones.length === 0) {
                    console.warn("oh damn, they didn't register an email or phone");
                    const search_result_el = forgotSection.querySelector('.search-result p');
                    if (search_result_el) {
                        search_result_el.innerHTML = 'You do not have an email or phone on file';
                    }
                }
                else if (!rv.claimed) {
                    console.warn("oh damn, they didn't register and claim this vehicle yet");
                    const search_result_el = forgotSection.querySelector('.search-result p');
                    if (search_result_el) {
                        search_result_el.innerHTML = 'We have a record of this vehicle but a registered account has not claimed it yet. You must register first, then claim the vehicle. You cannot use this vehicle as an identity to recover a login.';
                    }
                }
                else {
                    const search_result_el = forgotSection.querySelector('.search-result');
                    if (search_result_el) {
                        const resultP = search_result_el.querySelector('p');
                        if (resultP) {
                            resultP.innerText = 'Vehicle found, you may send a reset link to:';
                        }
                        const dl_el = search_result_el.querySelector('dl');

                        if (dl_el) {
                            while (dl_el.lastElementChild) {
                                dl_el.removeChild(dl_el.lastElementChild);
                            }

                            const ells = [];
                            
                            // Process emails with obscuring
                            rv.emails.forEach(([id, v]) => {
                               console.log(v);
                               const dt = document.createElement('dt');
                               const dd = document.createElement('dd');
                               const inp = document.createElement('input');
                               inp.setAttribute('type', 'checkbox');
                               inp.setAttribute('data-person-id', id);
                               inp.setAttribute('data-contact-value', v);
                               inp.setAttribute('data-contact-type', 'email');
                               dt.innerText = obscure_email(v);
                               dt.setAttribute('data-owner-id', id);
                               dd.appendChild(inp);
                               ells.push(dt);
                               ells.push(dd);
                            });
                            
                            // Process phones with obscuring
                            rv.phones.forEach(([id, v]) => {
                               console.log(v);
                               const dt = document.createElement('dt');
                               const dd = document.createElement('dd');
                               const inp = document.createElement('input');
                               inp.setAttribute('type', 'checkbox');
                               inp.setAttribute('data-person-id', id);
                               inp.setAttribute('data-contact-value', v);
                               inp.setAttribute('data-contact-type', 'phone');
                               dt.innerText = obscure_phone(v);
                               dt.setAttribute('data-owner-id', id);
                               dd.appendChild(inp);
                               ells.push(dt);
                               ells.push(dd);
                            });
                            
                            dl_el.append(...ells);
                        }
                        
                        // Update send-reset-link button state
                        updateSendResetLinkButtonState();
                    }
                }
            } else {
                const search_result_el = forgotSection.querySelector('.search-result p');
                if (search_result_el) {
                    search_result_el.innerHTML = 'Vehicle not found. Please check your tag/VIN and state and try again.';
                }
            }
        })
        .catch((err) => {
            console.error(err);
            el.classList.remove('activated');
            const search_result_el = forgotSection.querySelector('.search-result p');
            if (search_result_el) {
                search_result_el.innerHTML = 'Error searching for vehicle. Please try again.';
            }
        });
    }
}

function getParkrangerLoginOverlay() {
    return document.querySelector('#parkranger-login-overlay');
}

function openParkrangerLoginOverlay() {
    const overlay = getParkrangerLoginOverlay();
    if (!overlay) {
        return;
    }
    overlay.classList.remove('hidden');
    const emailInput = overlay.querySelector('#parkranger-email');
    if (emailInput) {
        emailInput.focus({preventScroll: true});
    }
}

function closeParkrangerLoginOverlay() {
    const overlay = getParkrangerLoginOverlay();
    if (!overlay) {
        return;
    }
    overlay.classList.add('hidden');
}

function showForgotPasswordSection() {
    closeParkrangerLoginOverlay();
    const forgotSection = document.querySelector('#forgot-email-password');
    if (!forgotSection) {
        return;
    }
    forgotSection.classList.remove('hidden');
    // Reveal-only previously left users staring at an unchanged
    // viewport ("forgot link is dead"). Scroll it into view and
    // focus the first field so the action is obvious.
    forgotSection.scrollIntoView({behavior: 'smooth', block: 'center'});
    const stateSelect = forgotSection.querySelector('select#vehicle-tag-state');
    if (stateSelect) {
        stateSelect.focus({preventScroll: true});
    }
}

function handler__click__login_with_parkranger(ev) {
    console.log(ev);
    ev.preventDefault();
    ev.stopPropagation();

    const parent = ev.target.closest('.parkranger-login-box');
    if (!parent) {
        return;
    }
    const email = parent.querySelector('#parkranger-email')?.value;
    const password = parent.querySelector('#parkranger-password')?.value;
    const submitButton = parent.querySelector('button[type="submit"]');
    const nextFromButton = submitButton?.getAttribute('data-attr-next-page');
    const nextFromHidden = document.querySelector('input[name="next"]')?.value;
    const next_page = nextFromButton || nextFromHidden || '/';

    runWithBusy(submitButton, () => {
        return postData('/account/login/', {email, password, next_page}, {fetch_msg: 'logging in'})
            .then((response) => {
                console.log(response);
                if (response.valid === false && response.redirect) {
                    location.assign(response.redirect);
                    return;
                }
                if (response.valid) {
                    saveLastLogin({email, idp: 'parkranger'});
                    location.assign(response.next_page || next_page || '/');
                    return;
                }
                pop_toast({
                    topic: 'Sign in failed',
                    message: 'Email or password was not accepted. Try again, or use Google.',
                    warning: true,
                });
            });
    }, {disable: true})
        .catch((err) => {
            console.warn('ParkRanger login failed', err);
            pop_toast({
                topic: 'Sign in failed',
                message: 'Could not reach the server. Check your connection and try again.',
                warning: true,
            });
        });
}

/**
 * Mark the Google OAuth submit control busy so a swallowed POST is not silent.
 * Do not set disabled — some mobile browsers cancel the in-flight form submit.
 * @param {HTMLButtonElement | null} buttonEl
 */
function markGoogleOauthButtonPending(buttonEl) {
    if (!buttonEl) {
        return;
    }
    buttonEl.dataset.busy = 'true';
    buttonEl.setAttribute('aria-busy', 'true');
    buttonEl.setAttribute('aria-disabled', 'true');
    buttonEl.setAttribute('aria-label', 'Signing in with Google');
}

/**
 * Clear Google OAuth pending markers (bfcache / back from accounts.google.com).
 */
function clearGoogleOauthButtonsPending() {
    document.querySelectorAll('form[action*="google-oauth2"] button[data-busy="true"]')
        .forEach((btn) => {
            delete btn.dataset.busy;
            btn.removeAttribute('aria-busy');
            btn.removeAttribute('aria-disabled');
            btn.removeAttribute('aria-label');
        });
}

/**
 * Native POST to social:begin — do not preventDefault.
 * @param {SubmitEvent} ev
 */
function handler__submit__google_oauth(ev) {
    const form = ev.currentTarget;
    if (!(form instanceof HTMLFormElement)) {
        return;
    }
    markGoogleOauthButtonPending(form.querySelector('button[type="submit"]'));
}

function bindGoogleOauthPendingState() {
    document.querySelectorAll('form[action*="google-oauth2"]').forEach((form) => {
        form.addEventListener('submit', handler__submit__google_oauth);
    });
    window.addEventListener('pageshow', (ev) => {
        if (ev.persisted) {
            clearGoogleOauthButtonsPending();
        }
    });
}

function page_setup() {
    let el, els;
    applyAccountPageVersion('account_login');
    el = document.querySelector('#registration-options');
    if (el) {
        el.addEventListener('click', (ev) => {
            handler__click__registration_type_card(ev);
        });
    }

    els = document.querySelectorAll('#registration-options .register-button');
    els.forEach((el) => {
        el.addEventListener('click', (ev) => {
            handler__click__register_me(ev);
        });
    });

    el = document.querySelector('#forgot-email-password');
    if (el) {
        el.addEventListener('click', (ev) => {
            handler__click__search_forgottens(ev);
        });
        
        // Handle find button
        const findButton = el.querySelector('button[name="find"]');
        if (findButton) {
            findButton.addEventListener('click', (ev) => {
                handler__click__search_forgottens(ev);
            });
        }
        
        // Handle send-reset-link button
        const sendResetButton = el.querySelector('button[name="send-reset-link"]');
        if (sendResetButton) {
            sendResetButton.addEventListener('click', (ev) => {
                handler__click__send_reset_link(ev);
            });
        }
        
        // Handle cancel button
        const cancelButton = el.querySelector('button[name="cancel"]');
        if (cancelButton) {
            cancelButton.addEventListener('click', (ev) => {
                el.classList.remove('show');
                // Reset form
                const tagInput = el.querySelector('#vehicle-tag');
                const stateSelect = el.querySelector('#vehicle-tag-state');
                const searchResult = el.querySelector('.search-result');
                if (tagInput) tagInput.value = '';
                if (stateSelect) stateSelect.value = '';
                if (searchResult) {
                    searchResult.querySelector('p').innerHTML = '';
                    searchResult.querySelector('dl').innerHTML = '';
                }
                updateSendResetLinkButtonState();
            });
        }
        
        // Use event delegation for dynamically created checkboxes
        const dl_el = el.querySelector('.search-result dl');
        if (dl_el) {
            dl_el.addEventListener('change', (ev) => {
                if (ev.target.type === 'checkbox') {
                    updateSendResetLinkButtonState();
                }
            });
        }
        
        // Handle ID Me button (now inside details)
        const idMeButton = el.querySelector('button[name="id-me"]');
        if (idMeButton) {
            idMeButton.addEventListener('click', (ev) => {
                handler__click__search_forgottens(ev);
            });
        }
    }

    els = document.querySelectorAll('.photo-capture input[type="file"]');
    if (els) {
        els.forEach((el) => {
            el.addEventListener('change', (ev) => {
                handler__take_photo(ev);
                // enable the ID me button
                const idMeButton = document.querySelector('#forgot-email-password button[name="id-me"]');
                if (idMeButton) {
                    idMeButton.removeAttribute('disabled');
                }
            });
        });
    }

    const openPrLogin = document.querySelector('.open-parkranger-login');
    if (openPrLogin) {
        openPrLogin.addEventListener('click', (ev) => {
            ev.preventDefault();
            openParkrangerLoginOverlay();
        });
    }

    const prLoginOverlay = getParkrangerLoginOverlay();
    if (prLoginOverlay) {
        prLoginOverlay.addEventListener('click', (ev) => {
            if (ev.target === prLoginOverlay) {
                closeParkrangerLoginOverlay();
                return;
            }
            if (ev.target.closest('.parkranger-login-close')) {
                closeParkrangerLoginOverlay();
                return;
            }
            if (ev.target.closest('.help-login-button')) {
                showForgotPasswordSection();
            }
        });

        const prLoginForm = prLoginOverlay.querySelector('form.parkranger-login-box');
        if (prLoginForm) {
            prLoginForm.addEventListener('submit', (ev) => {
                handler__click__login_with_parkranger(ev);
            });
        }
    }

    document.addEventListener('keydown', (ev) => {
        if (ev.key !== 'Escape') {
            return;
        }
        const overlay = getParkrangerLoginOverlay();
        if (overlay && !overlay.classList.contains('hidden')) {
            closeParkrangerLoginOverlay();
        }
    });

    // Password reset PIN verification
    const passwordResetPinInput = document.querySelector('#password-reset-pin-received');
    if (passwordResetPinInput) {
        passwordResetPinInput.addEventListener('paste', (ev) => {
            ev.preventDefault();
            let paste = (ev.clipboardData || window.clipboardData).getData('text/plain');
            const data = [...paste].map((c) => {
                if ('0123456789'.indexOf(c) !== -1) {
                    return c;
                }
            }).join('');
            ev.target.value = data;
            const nev = new Event('keyup');
            ev.target.dispatchEvent(nev);
        });
        
        passwordResetPinInput.addEventListener('keyup', (ev) => {
            handler__change__verify_password_reset_pin(ev);
        });
    }

    // Password reset password inputs - listen to both input and keyup events
    const passwordResetPasswordInputs = document.querySelectorAll('input[name^="password-reset-password"]');
    passwordResetPasswordInputs.forEach((el) => {
        // input event fires on every character change (including paste)
        el.addEventListener('input', (ev) => {
            handler__change__password_reset_equality(ev);
        });
        // keyup as fallback for older browsers
        el.addEventListener('keyup', (ev) => {
            handler__change__password_reset_equality(ev);
        });
    });

    // Password visibility toggle buttons - use event delegation in case section is hidden
    const passwordResetSection = document.querySelector('#password-reset-pin-section');
    if (passwordResetSection) {
        passwordResetSection.addEventListener('click', (ev) => {
            if (ev.target.closest('.toggle-password-visibility')) {
                handler__click__toggle_password_visibility(ev);
            }
        });
    }

    // Password reset finish button
    const finishPasswordResetButton = document.querySelector('button[name="finish-password-reset"]');
    if (finishPasswordResetButton) {
        finishPasswordResetButton.addEventListener('click', (ev) => {
            handler__click__finish_password_reset(ev);
        });
    }

    bindGoogleOauthPendingState();

    setupDocumentEventListeners();

    // One-shot: visitor accepted the bottom re-login prompt — open matching IdP.
    // Defer so overlay listeners (openParkrangerLoginOverlay) are ready.
    setTimeout(() => {
        applyLastLoginAutoOnLoginPage();
    }, 50);
}

/**
 * Validate password against rules (reused from register.js pattern)
 */
function validate_password_rules_password_reset(data) {
    const pw_rules_el = document.querySelector('#password-reset-pw-rules');
    if (!pw_rules_el) {
        return false;
    }
    
    let accepted = true;

    let el = pw_rules_el.querySelector('.pw-rule-length');
    if (data.length >= 12 && data.length <= 32) {
        el.classList.remove('rejected');
        el.classList.add('accepted');
    } else {
        el.classList.remove('accepted');
        el.classList.add('rejected');
        accepted = false;
    }

    el = pw_rules_el.querySelector('.pw-rule-upper');
    if (data.match(/\p{Lu}/u)) {
        el.classList.remove('rejected');
        el.classList.add('accepted');
    } else {
        el.classList.remove('accepted');
        el.classList.add('rejected');
        accepted = false;
    }

    el = pw_rules_el.querySelector('.pw-rule-lower');
    if (data.match(/\p{Ll}/u)) {
        el.classList.remove('rejected');
        el.classList.add('accepted');
    } else {
        el.classList.remove('accepted');
        el.classList.add('rejected');
        accepted = false;
    }

    el = pw_rules_el.querySelector('.pw-rule-digit');
    if (/\d/.test(data)) {
        el.classList.remove('rejected');
        el.classList.add('accepted');
    } else {
        el.classList.remove('accepted');
        el.classList.add('rejected');
        accepted = false;
    }

    el = pw_rules_el.querySelector('.pw-rule-special');
    if (/\W/.test(data)) {
        el.classList.remove('rejected');
        el.classList.add('accepted');
    } else {
        el.classList.remove('accepted');
        el.classList.add('rejected');
        accepted = false;
    }

    return accepted;
}

/**
 * Handle PIN verification for password reset
 */
function handler__change__verify_password_reset_pin(ev) {
    const pinInput = ev.target;
    pinInput.classList.remove('rejected');
    pinInput.classList.remove('accepted');
    
    const pin = pinInput.value.trim();
    if (pin.length !== 6) {
        return;
    }

    const profile_id = parseInt(pinInput.getAttribute('data-profile-id'), 10);
    const method = pinInput.getAttribute('data-method') || 'email';
    
    if (!profile_id) {
        console.warn('No profile_id found for PIN verification');
        return;
    }

    const passwordInputs = document.querySelectorAll('#password-reset-pin-section input[name^="password-reset-password"]');
    const passwordLabels = document.querySelectorAll('#password-reset-pin-section label[for^="password-reset-password"]');

    const data = {
        profile_id: profile_id,
        pin: pin,
        method: method
    };
    
    console.log('verifying password reset PIN', data);

    postJSONData('/account/password/reset/by-vehicle/confirm/', data, {fetch_msg: 'verifying PIN'})
        .then((response) => {
            console.log(response);

            if (response && response.valid) {
                // Enable the password boxes
                pinInput.classList.add('accepted');
                passwordInputs.forEach((el) => {
                    el.removeAttribute('disabled');
                });
                passwordLabels.forEach((el) => {
                    el.removeAttribute('disabled');
                });
                
                // Enable password visibility toggle buttons
                const toggleButtons = document.querySelectorAll('#password-reset-pin-section .toggle-password-visibility');
                toggleButtons.forEach((btn) => {
                    btn.removeAttribute('disabled');
                });
                
                stop_countdown_timer();
                const timerEl = document.querySelector('#password-reset-pin-timer');
                if (timerEl) {
                    timerEl.innerHTML = '';
                }
                
                // Store profile_id for password setting
                passwordInputs[0].setAttribute('data-profile-id', profile_id);
            } else {
                pinInput.classList.add('rejected');
                passwordInputs.forEach((el) => {
                    el.setAttribute('disabled', 'disabled');
                });
                passwordLabels.forEach((el) => {
                    el.setAttribute('disabled', 'disabled');
                });
            }
        })
        .catch((error) => {
            console.error('PIN verification error:', error);
            pinInput.classList.add('rejected');
        });
}

/**
 * Handle password visibility toggle
 */
function handler__click__toggle_password_visibility(ev) {
    // Find the button - handle clicks on icon or button itself
    // When using event delegation, ev.target might be the icon
    let button = ev.target.closest('.toggle-password-visibility');
    if (!button) {
        // Fallback: check if target is the button itself
        if (ev.target.classList && ev.target.classList.contains('toggle-password-visibility')) {
            button = ev.target;
        } else {
            return;
        }
    }
    
    // Ensure we have a button element
    if (button.tagName !== 'BUTTON') {
        return;
    }
    
    // Don't proceed if button is disabled
    if (button.hasAttribute('disabled')) {
        return;
    }
    
    const targetId = button.getAttribute('data-target');
    if (!targetId) {
        return;
    }
    
    const passwordInput = document.getElementById(targetId);
    if (!passwordInput) {
        console.warn(`Could not find password input with id: ${targetId}`);
        return;
    }
    
    // Toggle visibility
    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        // Replace icon with eye-slash - FontAwesome will replace <i> with <svg>
        button.innerHTML = '<i class="fa-solid fa-eye-slash"></i>';
    } else {
        passwordInput.type = 'password';
        // Replace icon with eye - FontAwesome will replace <i> with <svg>
        button.innerHTML = '<i class="fa-solid fa-eye"></i>';
    }
}

/**
 * Handle password change validation and enable/disable finish button
 */
function handler__change__password_reset_equality(ev) {
    const passwd1_el = document.querySelector('#password-reset-password-1');
    const passwd2_el = document.querySelector('#password-reset-password-2');
    const button = document.querySelector('button[name="finish-password-reset"]');

    if (!passwd1_el || !passwd2_el || !button) {
        return;
    }

    // Always validate password rules on first password field, even if second is empty
    const pwrules_valid = validate_password_rules_password_reset(passwd1_el.value);

    // If either field is empty, disable button and clear accepted/rejected classes
    if (passwd1_el.value.length === 0 || passwd2_el.value.length === 0) {
        passwd1_el.classList.remove('accepted');
        passwd2_el.classList.remove('accepted');
        // Only show rejected if password1 has content but doesn't meet rules
        if (passwd1_el.value.length > 0 && !pwrules_valid) {
            passwd1_el.classList.add('rejected');
        } else {
            passwd1_el.classList.remove('rejected');
        }
        passwd2_el.classList.remove('rejected');
        button.setAttribute('disabled', 'disabled');
        return;
    }

    // Both fields have content - check if they match and rules are valid
    if (passwd1_el.value !== passwd2_el.value) {
        passwd1_el.classList.remove('accepted');
        passwd2_el.classList.remove('accepted');
        passwd1_el.classList.add('rejected');
        passwd2_el.classList.add('rejected');
        button.setAttribute('disabled', 'disabled');
    } else if (pwrules_valid) {
        passwd1_el.classList.remove('rejected');
        passwd2_el.classList.remove('rejected');
        passwd1_el.classList.add('accepted');
        passwd2_el.classList.add('accepted');
        button.removeAttribute('disabled');
    } else {
        // Passwords match but rules not valid
        passwd1_el.classList.remove('accepted');
        passwd2_el.classList.remove('accepted');
        passwd1_el.classList.add('rejected');
        passwd2_el.classList.add('rejected');
        button.setAttribute('disabled', 'disabled');
    }
}

/**
 * Handle finish password reset button click
 */
function handler__click__finish_password_reset(ev) {
    const passwd1_el = document.querySelector('#password-reset-password-1');
    const profile_id = passwd1_el ? passwd1_el.getAttribute('data-profile-id') : null;
    const button = document.querySelector('button[name="finish-password-reset"]');
    
    if (!passwd1_el || !profile_id) {
        console.warn('Cannot set password: missing profile_id or password');
        return;
    }

    const password = passwd1_el.value;
    button.classList.add('activated');

    const data = {
        temp_profile_id: parseInt(profile_id, 10),
        password: password
    };
    
    postData('/account/register/password/set/', data, {fetch_msg: 'setting password'})
        .then((response) => {
            console.log(response);
            button.classList.remove('activated');
            if (response && response.valid) {
                // Redirect to login or identity confirmation page
                window.location = '/account/login/';
            }
        })
        .catch((error) => {
            console.error(error);
            button.classList.remove('activated');
        });
}

document.addEventListener('DOMContentLoaded', page_setup);

//# debugId=13dd5fc6-77c9-59c3-b5a4-7effb8f52b2b
